export default __webpack_public_path__ + "static/media/5.62db2511.svg";